import { render } from "./BakedGoods.vue?vue&type=template&id=268fd8a3&scoped=true"
import script from "./BakedGoods.vue?vue&type=script&lang=js"
export * from "./BakedGoods.vue?vue&type=script&lang=js"

import "./BakedGoods.vue?vue&type=style&index=0&id=268fd8a3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268fd8a3"]])

export default __exports__